var getTrackSize = function getTrackSize(size) {
  return size === 'l' ? 'l' : 'default';
};
var getDynamicTrackProgress = function getDynamicTrackProgress(state) {
  switch (state) {
    case 'current':
      return 100;
    case 'past':
    case 'future':
    default:
      return 0;
  }
};
var getProgressionTrackProgress = function getProgressionTrackProgress(state, progress) {
  switch (state) {
    case 'past':
      return 100;
    case 'current':
      return progress || 0;
    case 'future':
    default:
      return 0;
  }
};
var getTrackProgress = function getTrackProgress(type, state, progress) {
  return type === 'dynamic' ? getDynamicTrackProgress(state) : getProgressionTrackProgress(state, progress);
};
var getMarkerVerticalSpacing = function getMarkerVerticalSpacing(_) {
  return '4';
};
var getMarkerHorizontalSpacing = function getMarkerHorizontalSpacing(size) {
  if (!size || size !== 'l') return '8';
  return '12';
};
var getMarkerContainerHorizontalSpacing = function getMarkerContainerHorizontalSpacing(size, startSlot, endSlot) {
  var space = !size || size !== 'l' ? '8' : '12';
  if (startSlot && endSlot) {
    return {
      mx: space
    };
  }
  if (endSlot) {
    return {
      me: space
    };
  }
  if (startSlot) {
    return {
      ms: space
    };
  }
  return {
    mx: space
  };
};

export { getMarkerContainerHorizontalSpacing, getMarkerHorizontalSpacing, getMarkerVerticalSpacing, getTrackProgress, getTrackSize };
//# sourceMappingURL=Step.helpers.js.map
